<template>
  <div style="height: 100%; width: 100%">
    <div class="bg-box">
      <div class="content" v-if="info">
        <div class="title">电 子 股 权 证</div>
        <p class="code">
          编 号:
          <span style="color: #f66">{{ info.master.shareCerNo }}</span>
        </p>
        <p class="text">
          为深化农村集体经济产权制度改革,发展壮大农
          村集体经济,赋予农民集体收益分配权，增加农民财
          产性收入，让广大农民群众共享改革红利。根据国家
          有关农村集体产权制度改革文化精神和法律、法规规
          定，经集体经济组织成员(代表)大会表决通过，对本
          村、组集体资产股份量化确权到户。
        </p>
        <div class="org-info">
          <div class="org-name">
            <div class="org-title">集体经济组织信息</div>
            <p class="org-name-text">组织名：{{ info.org.name }}</p>
            <p class="org-name-text">组织编号：{{ info.org.code }}</p>
            <p class="org-name-text">组织地址：{{ info.org.address }}</p>
            <p class="org-name-text">
              入驻时间：{{ timeFilter(info.org.createTime) }}
            </p>
            <p class="org-name-text" v-if="info.org.resourceShares">
              总资源股：{{ info.org.resourceShares }}
            </p>
            <p class="org-name-text" v-if="info.org.assetShares">
              总资产股：{{ info.org.assetShares }}
            </p>
            <p class="org-name-text" v-if="info.org.shareAmount">
              总股份数：{{ info.org.shareAmount }}
            </p>
            <p class="org-name-text" v-if="info.org_shareAmount">
              集体持有股份：{{ info.org_shareAmount }}
            </p>
            <p class="org-name-text" v-if="info.org_assetShares">
              集体持有资产股：{{ info.org_assetShares }}
            </p>
            <p class="org-name-text" v-if="info.org_resourceShares">
              集体持有资源股：{{ info.org_resourceShares }}
            </p>
          </div>
        </div>
        <div class="org-info">
          <div class="org-name">
            <div class="org-title">家庭户信息</div>
            <p class="org-name-text">
              户主姓名：{{ info.master.familyMaster }}
            </p>
            <p class="org-name-text">家庭地址：{{ info.master.address }}</p>
            <p class="org-name-text">
              家庭股份数：{{ info.master.shareAmount }}
            </p>
            <p class="org-name-text">
              家庭资产股：{{ info.master.assetShare }}
            </p>
            <p class="org-name-text">
              家庭资源股：{{ info.master.resourceShares }}
            </p>
            <p class="org-name-text">
              股权证编号: {{ info.master.shareCerNo }}
            </p>
          </div>
        </div>
        <div class="org-info">
          <div class="org-name">
            <div class="org-title">家庭户成员信息</div>
            <div
              class="user-list"
              v-for="(item, index) in info.menberArray"
              :key="index"
            >
              <div class="item">
                <p v-if="item.realName">姓名：{{ item.realName }}</p>
                <p v-if="String(item.sex) != ''">
                  性别：{{ filterSex(item.sex) }}
                </p>
                <p v-if="item.shareAmount">
                  成员股份数：{{ item.shareAmount }}
                </p>
                <p v-if="item.assetShares">
                  成员资产股：{{ item.assetShares }}
                </p>
                <p v-if="item.resourceShares">
                  成员资源股：{{ item.resourceShares }}
                </p>
                <p v-if="item.idNumber">
                  身份证：{{ filterCard(item.idNumber) }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          &copy; 遵义云讯网络科技有限责任公司
          <p>
            &copy;2019
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52030302000614"
              target="_blank"
              class="beian"
            >
              <image src="../assets/image/beian.png" class="image-box"></image>
              <span>黔ICP备19011880号</span>
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      orgId: "",
      familyNumber: "",
      info: "",
    };
  },
  methods: {
    getData(cnt) {
      this.$api.getFamilyInfo(cnt, (res) => {
		  console.log('===========');
		  console.log(res);
        if (res.data.rc == this.$util.RC.SUCCESS) {
          this.info =res.data.c
        } else {
          this.info = "";
        }
        console.log(this.info);
      });
    },
    filterCard(card) {
      let strCard = "";
      let str = card;
      let num = 0;
      if (card.indexOf("-") == -1) {
        strCard = card;
      } else {
        while (str.indexOf("-") !== -1) {
          str = str.slice(str.indexOf("-") + 1);
          num += 1;
        }
        if (num == 1) {
          strCard = card.substring(0, card.indexOf("-"));
        } else {
          strCard = "";
        }
      }
      return strCard;
    },
    timeFilter(val) {
      let date = new Date(val);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      let currentdate = year + " 年 " + month + " 月 " + strDate + " 日";
      return currentdate;
    },
    filterSex(val) {
      let str = "";
      if (val == 0) {
        str = "男";
      } else if (val == 1) {
        str = "女";
      }
      return str;
    },
  },
  mounted() {
    this.orgId = this.$route.query.orgId;
    this.familyNumber = this.$route.query.familyNumber;
	console.log(this.$route.query.orgId)
	console.log(this.$route.query.familyNumber)
    let cnt = {
      familyNumber: this.familyNumber,
      orgId: this.orgId,
    };
	// console.log(cnt);
    // let cnt = {
    //   familyNumber: 1000,
    //   orgId: 403690353782633
    // };

    this.getData(cnt);
  },
};
</script>

<style lang="scss" scoped>
.bg-box {
  width: 100%;
  min-height: 100%;
  background-image: url("../assets/image/bg.jpg");
  // background-size: 100%;
  background-position: center;
  background-size: cover;
}
.content {
  min-height: 100%;
  padding: 0 1.5rem 2rem 1.5rem;

  background: rgba($color: #fff, $alpha: 0.4);
}
.title {
  width: 100%;
  min-height: 5rem;
  line-height: 5rem;
  text-align: center;
  font-weight: 600;
  font-size: 2.2rem;
  color: #7dacc0;
}
.code {
  width: 100%;
  height: 4rem;
  margin-top: 1rem;
  color: #333;
  font-weight: 600;
  font-size: 1.8rem;
}
.text {
  margin-top: 1rem;
  color: #333;
  font-size: 1.4rem;
  line-height: 2rem;
}

.org-info {
  width: 100%;
  margin-top: 2rem;
}
.org-name {
  width: 100%;
}
.org-title {
  width: 100%;
  height: 4rem;
  line-height: 4rem;
  color: #fff;
  font-size: 1.6rem;
  text-align: center;
  background: #98cee5;
  border-radius: 5px;
}
.org-name-text {
  margin-top: 1rem;
  width: 100%;
  font-size: 1.6rem;
  line-height: 2rem;
}

.user-list {
  margin-top: 1rem;
  padding: 1rem;
  border-radius: 5px;
  background: rgba($color: #fff, $alpha: 0.8);
  font-size: 1.6rem;
  color: #333;
}
.item p {
  line-height: 3rem;
}
.footer {
  margin-top: 4rem;
  width: 100%;
  height: 4rem;
  color: #666;
  font-size: 1.4rem;
  text-align: center;
}
</style>